// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'          //引入axios
import Footer from "@/components/Footer/index";
import Header from "@/components/Header/Header";
import './assets/css/base.scss';
import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

Vue.prototype.$axios = axios;      // 把axios挂载到vue上

// Vue.prototype.$serverAddress = 'admin.gdsme.org';      // 服務器地址
Vue.prototype.$serverAddress = 'localhost';      // 服務器地址

import {
    vueBaberrage
} from 'vue-baberrage'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(vueBaberrage)

// 注册全局组件;
Vue.component('Footer', Vue.extend(Footer));
Vue.component('Header', Vue.extend(Header));

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js